import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import '@mantine/core/styles.css'
import '@mantine/notifications/styles.css'
import App from '@/App'
import '@/styles/global.css'

if (typeof history !== 'undefined' && 'scrollRestoration' in history) {
  history.scrollRestoration = 'manual'
}

function reloadOnceAfterChunkLoadFailure() {
  if (typeof window === 'undefined') return
  const key = 'sd2_chunk_reload_attempted'
  if (window.sessionStorage.getItem(key) === '1') return
  window.sessionStorage.setItem(key, '1')
  window.location.reload()
}

if (typeof window !== 'undefined') {
  window.addEventListener('vite:preloadError', (event) => {
    event.preventDefault()
    reloadOnceAfterChunkLoadFailure()
  })
  window.addEventListener('unhandledrejection', (event) => {
    const message = event.reason instanceof Error ? event.reason.message : String(event.reason || '')
    if (message.includes('Failed to fetch dynamically imported module') || message.includes('Importing a module script failed')) {
      event.preventDefault()
      reloadOnceAfterChunkLoadFailure()
    }
  })
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
